<template lang="pug">
.date-picker.row.between
  .overlay(v-if="showCalendar" @click="showCalendar = false;")
  transition(name="fade")
    vue-calendar(:style="{top: $el.clientHeight +'px'}" v-if="showCalendar" :domain="domain" @select="selected_date = $event; showCalendar = false; on_change()" :active="selected_date")
  .date.row.center.left(@click="showCalendar = !showCalendar" :class="{ active: showCalendar }")
    slot(name="date" :displayed_date="displayed_date" :selected_date="selected_date")
      span {{ displayed_date || 'DD/MM/YYYY' }}
</template>
<script>
export default {
  props: ['domain', 'metadata', 'date'],
  data() {
    return {
      showCalendar: false,
      selected_date: this.date || this.metadata && this.metadata.start_date,
    }
  },
  computed: {
    displayed_date() {
      return (this.selected_date && this.date_format(new Date(this.selected_date))) || (this.date && this.date_format(new Date(this.date)))
    },
    date_format() {
      const default_format = d =>  d.format('%d/%m/%Y')
      return this.metadata && this.metadata.date_format || default_format
    }
  },
  methods: {
    on_change() {
      if (!this.selected_date) return
      this.$emit('select',this.selected_date)
    }
  },
  watch: {
    // selected_date() { this.on_change() },
    date: function(newVal,oldVal) { this.selected_date = newVal },
  }
}
</script>
<style>
.date-picker {
  height: fit-content;
  position: relative;
  max-width: fit-content;
}
/* .date-picker.hours {
  max-width: 120px;
} */
.date-picker .date, .date-picker .time, .date-picker .dash {
  /* padding: 4px 8px; */
  position: relative;
  /* height: 100%;
  font-size: 14px; */
}
.date-picker .date:hover, .date-picker .time:hover {
  cursor: pointer;
}
/* .date-picker .date { min-width: 120px; } */
.date-picker .vue-calendar { position: absolute; left: 0; z-index: 100;  box-shadow: rgba(74, 105, 160, 0.08) 0px 2px 18px 0px;}
.date-picker .overlay { position: fixed; width: 100vw; height: 100vh; z-index: 99; top: 0; left:0;}
.date-picker .date:before, .date-picker .time:before {
  content: "";
  position: absolute;
  width: calc(100% - 32px);
  height: 2px;
  bottom: 0;
  left: 16px;
  background-color: var(--primary);
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}
.date-picker .date.active:before, .date-picker .time.active:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
.date-picker .time { min-width: 66px; }
/* .date-picker .time.active { background: none; } */
.date-picker .dropdown {
  position: absolute;
  background: white;
  z-index: 100;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 18px 0px;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: scroll;
  width: 100px;
  top: 40px;
  right: -17px;
}
.date-picker .dropdown .hour { padding: 8px 16px;}
.date-picker .dropdown .hour:hover { background: rgba(0, 0, 0,.1); cursor: pointer;}
.date-picker .dropdown .hour.active { background: var(--primary); color: white;}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.date-picker .date .chevron-right { transform: rotate(90deg); }
.fade-enter, .fade-leave-to  {
  opacity: 0;
}

</style>
